import {NgModule} from "@angular/core";
import {RouterModule, Routes} from "@angular/router";
import {HomeComponent} from "./home/home.component";
import {CarteiraComponent} from "./carteira/carteira.component";
import {GrupoCarteiraComponent} from "./grupo-carteira/grupo-carteira/grupo-carteira.component";
import {GerenciadorRegistrosComponent} from "./grupo-carteira/gerenciar-registro/gerenciador-registros.component";
import {AssociacaoTabComponent} from "./associacao/associacao-tab/associacao-tab.component";
import {ResultadoRegraTabComponent} from "./resultado-regra/resultado-regra-tab/resultado-regra-tab.component";
import {ProcessamentoPesquisaComponent} from "./processamento/processamento-pesquisa/processamento-pesquisa.component";
import {RegraSimplesComponent} from "./regra/regra-simples/regra-simples.component";
import {RegraCompostaComponent} from "./regra/regra-composta/regra-composta.component";
import {AuthGuard} from "./guards/auth.guard";
import {FeitoConferidoComponent} from "./feito-conferido/feito-conferido.component";
import {TrilhaAuditoriaComponent} from "./trilha-auditoria/trilha-auditoria.component";
import {
  AssociacaoGrupoCarteiraTabComponent
} from "./associacao-grupo-carteira/associacao-grupo-carteira-tab/associacao-grupo-carteira-tab.component";
import { HistoricoTabComponent } from "./relatorio-historico/historico-tab/historico-tab.component";

const routes: Routes = [
  {path: "*", redirectTo: "home"},
  {path: "", redirectTo: "home", pathMatch: "full"},
  {path: "home", component: HomeComponent, canActivate: [AuthGuard]},
  {path: "dashboard", component: HomeComponent, canActivate: [AuthGuard]},
  {path: "resultadoRegra", component: ResultadoRegraTabComponent, canActivate: [AuthGuard]},
  {path: "historico", component: HistoricoTabComponent, canActivate: [AuthGuard]},
  {path: "carteira", component: CarteiraComponent, canActivate: [AuthGuard]},
  {path: "grupo-carteira", component: GrupoCarteiraComponent, canActivate: [AuthGuard]},
  {path: "gerenciador-registros", component: GerenciadorRegistrosComponent, canActivate: [AuthGuard]},
  {path: "associacao-grupo-carteira", component: AssociacaoGrupoCarteiraTabComponent, canActivate: [AuthGuard]},
  {path: "processamento", component: ProcessamentoPesquisaComponent, canActivate: [AuthGuard]},
  {path: "associacao", component: AssociacaoTabComponent, canActivate: [AuthGuard]},
  {path: "regra-simples", component: RegraSimplesComponent, canActivate: [AuthGuard]},
  {path: "regra-composta", component: RegraCompostaComponent, canActivate: [AuthGuard]},
  {path: "feito-conferido", component: FeitoConferidoComponent, canActivate: [AuthGuard]},
  {path: "trilha-auditoria", component: TrilhaAuditoriaComponent, canActivate: [AuthGuard]},
  // aChamar a rota com guarda =>
  // { path: 'home', component: HomeComponent, canActivate: [AuthGuard]},
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {
}
